/**
 * CharGenAttribute enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file CharGenAttribute.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum CharGenAttribute {
  STR = 0,
  DEX = 1,
  CON = 2,
  WIS = 3,
  INT = 4,
  CHA = 5,
}